/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-18 10:29:10
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import classnames from 'classnames';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { Icon, Popover, ActionList } from '@shopify/polaris';
import {
  CirclePlusMajor,
  ViewMinor,
  HideMinor,
  DragHandleMinor,
  DeleteMinor
} from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { MAX_ELEMENT_PER_AREA, BUTTON_TYPE_OPTIONS } from 'src/constants/theme-settings';
import { MENU_ID } from 'src/constants/theme-settings.jsx';
import MovingElementModal from 'src/components/views/theme-settings/moving-element-modal';

type State = {
  isOpenMenuAdd: boolean,
  filteredElements: any[]
};

type Props = {
  id: string,
  title: string,
  icon: any,
  isCollapsible: boolean,
  activeMenuItem: string,
  updateType: string,
  children: any[],
  isHidden?: boolean,
  subMenu: any[],
  menus?: any[],
  updateField: Function,
  themeSettingDefaultValue: any,
  themeSettingDefaultThemeValue: any,
  formValues: any,
  handleChangeActiveMenuItem: (id: string, updateType: string) => void,
  handleUpdateMenuSetting: (id: string, children: any[], updateType: string) => void,
  handleToggleHideMenuItem?: (id: string, updateType: string) => void,
  upsertElementActions: (type: string, properties: Record<string, any>) => void
};

type ComposedProps = Props & WithI18nProps;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  ...draggableStyle,
  background: isDragging ? '#f6f6f7' : ''
});

const _dragEl = document.getElementById('draggable');

// const CLICK_IFRAME_EVENT = 'clickIframe';

class MenuItemArea extends Component<ComposedProps, State> {
  state = {
    isOpenMenuAdd: false,
    isActiveMovingElementModal: false,
    movingElementInfo: null,
    filteredElements: []
  };

  optionalPortal = (styles, element) => {
    if (styles.position === 'fixed') {
      return createPortal(element, _dragEl);
    }
    return element;
  };

  componentDidMount() {
    const { children } = this.props;
    this.handleFilterElements(children, this.props);
    // Emitter.on(CLICK_IFRAME_EVENT, this.handleClickIframe);
  }

  componentWillReceiveProps(nextProps) {
    const { children } = this.props;
    const { children: nextChildren } = nextProps;
    // Compare address of object js when reducer return a new clone of state
    if (children !== nextChildren) {
      this.handleFilterElements(nextChildren, nextProps);
    }
  }

  // componentWillUnmount() {
  //   Emitter.off(CLICK_IFRAME_EVENT, this.handleClickIframe);
  // }

  // handleClickIframe = () => {
  //   if (this.state.isOpenMenuAdd) {
  //     this.setState({
  //       isOpenMenuAdd: false
  //     });
  //   }
  // };

  handleFilterElements = (children, props) => {
    const { elements, id, menus } = props;

    let restChildren = [];
    if (
      [
        MENU_ID.PRODUCT_IMAGE_TOP,
        MENU_ID.PRODUCT_IMAGE_MIDDLE,
        MENU_ID.PRODUCT_IMAGE_BOTTOM
      ].includes(id) &&
      !_.isEmpty(menus)
    ) {
      // const mapRestChildren = {
      //   [MENU_ID.PRODUCT_IMAGE_TOP]: () => {
      //     const menuMid =
      //       menus.find(item => item.id === MENU_ID.PRODUCT_IMAGE_MIDDLE)?.children || [];
      //     const menuBottom =
      //       menus.find(item => item.id === MENU_ID.PRODUCT_IMAGE_BOTTOM)?.children || [];
      //     return [...menuMid, ...menuBottom];
      //   },
      //   [MENU_ID.PRODUCT_IMAGE_MIDDLE]: () => {
      //     const menuTop = menus.find(item => item.id === MENU_ID.PRODUCT_IMAGE_TOP)?.children || [];
      //     const menuBottom =
      //       menus.find(item => item.id === MENU_ID.PRODUCT_IMAGE_BOTTOM)?.children || [];
      //     return [...menuTop, ...menuBottom];
      //   },
      //   [MENU_ID.PRODUCT_IMAGE_BOTTOM]: () => {
      //     const menuTop = menus.find(item => item.id === MENU_ID.PRODUCT_IMAGE_TOP)?.children || [];
      //     const menuMid =
      //       menus.find(item => item.id === MENU_ID.PRODUCT_IMAGE_MIDDLE)?.children || [];
      //     return [...menuMid, ...menuTop];
      //   }
      // };
      const menuInformation =
        menus.find(item => item.id === MENU_ID.PRODUCT_INFORMATION)?.children || [];

      restChildren = [...menuInformation]; //[...mapRestChildren[id](), ...menuInformation];
    }

    this.setState({
      filteredElements: _.reject(
        elements,
        element =>
          !!children.find(item => {
            const [, name] = element?.value.split('_');
            return item.value.includes(name);
          }) ||
          !!restChildren.find(item => {
            const [, menuId] = item?.value.split('_');
            const [, elementId] = element?.value.split('_');
            return menuId === elementId;
          })
      )
    });
  };

  handleSelectMenuItem = (id: string) => {
    const { activeMenuItem, updateType, handleChangeActiveMenuItem } = this.props;
    if (id !== activeMenuItem) {
      handleChangeActiveMenuItem(id, updateType);
    }
  };

  handleTogglePopover = () => {
    this.setState({
      isOpenMenuAdd: !this.state.isOpenMenuAdd
    });
  };

  handleCheckExistElement = element => {
    const { id, menus } = this.props;
    const mapRestChildren = {
      [MENU_ID.PRODUCT_IMAGE_TOP]: () => {
        const menuMid =
          menus.find(item => item.id === MENU_ID.PRODUCT_IMAGE_MIDDLE)?.children || [];
        const menuBottom =
          menus.find(item => item.id === MENU_ID.PRODUCT_IMAGE_BOTTOM)?.children || [];
        return [...menuMid, ...menuBottom];
      },
      [MENU_ID.PRODUCT_IMAGE_MIDDLE]: () => {
        const menuTop = menus.find(item => item.id === MENU_ID.PRODUCT_IMAGE_TOP)?.children || [];
        const menuBottom =
          menus.find(item => item.id === MENU_ID.PRODUCT_IMAGE_BOTTOM)?.children || [];
        return [...menuTop, ...menuBottom];
      },
      [MENU_ID.PRODUCT_IMAGE_BOTTOM]: () => {
        const menuTop = menus.find(item => item.id === MENU_ID.PRODUCT_IMAGE_TOP)?.children || [];
        const menuMid =
          menus.find(item => item.id === MENU_ID.PRODUCT_IMAGE_MIDDLE)?.children || [];
        return [...menuMid, ...menuTop];
      }
    };
    const otherImageAreaElement = mapRestChildren[id]();
    const foundElement = otherImageAreaElement.find(item => {
      const suffix = element?.value?.split('_')[1];
      return item.value.includes(suffix);
    });
    return foundElement;
  };

  handleAddElement = element => {
    const {
      i18n,
      id,
      children,
      updateType,
      updateField,
      themeSettingDefaultValue,
      themeSettingDefaultThemeValue,
      handleUpdateMenuSetting,
      upsertElementActions
    } = this.props;

    const existElement = this.handleCheckExistElement(element);
    if (existElement) {
      this.setState({
        isActiveMovingElementModal: true,
        movingElementInfo: {
          element,
          from: existElement,
          to: id
        }
      });
      this.handleTogglePopover();
      return;
    }

    const { filteredElements } = this.state;
    this.handleTogglePopover();
    const [, elementName] = element?.value.split('_');

    const areaValue = `${id.split('_')[0]}_${elementName}`; // This is key of element by area
    const newChildren = [
      ...children,
      {
        ...element,
        value: areaValue,
        label: i18n.translate(element.label),
        isHidden: false
      }
    ];

    // Update redux form
    // If default value of match theme does not exist, take the default theme value one
    // Get value by common prefix without area in name -> Ex: productImage_productSaleLabel
    let setting = {};
    let keySetting = element?.value;

    // If adding a button, it will be set a buttonType already with the priority below
    // 1. selectOptionBtn
    // 2. qvBtn
    // 3. goToDetailBtn
    if (keySetting.includes('button')) {
      // Keys are: selectOptionBtn | qvBtn | goToDetailBtn
      const buttonKeySetting = this.getButtonKeySetting();
      keySetting = buttonKeySetting;
    }

    if (themeSettingDefaultValue && themeSettingDefaultValue[keySetting]) {
      setting = themeSettingDefaultValue[keySetting] || {};
    } else {
      setting = themeSettingDefaultThemeValue[keySetting] || {};
    }

    updateField(areaValue, {
      isHidden: false,
      ...setting,
      position: newChildren.length - 1
    });

    // Update menu in reducer
    handleUpdateMenuSetting(id, newChildren, updateType);
    const elements = newChildren?.[newChildren?.length - 1]?.value?.split('_');
    upsertElementActions('add', {
      feature: 'Theme Settings',
      selectedTheme: this.props.themeName,
      page: elements[0],
      elementName: elements[0] + '_' + elements[1]
    });

    setTimeout(() => {
      this.setState({
        filteredElements: _.reject(filteredElements, element =>
          newChildren.find(item => {
            const [, name] = element?.value.split('_');
            return item.value.includes(name);
          })
        )
      });
    }, 200);
  };

  getButtonKeySetting = () => {
    const { formValues } = this.props;
    const [productImagePrefix] = MENU_ID.PRODUCT_IMAGE.split('_');
    const buttonKeys = Object.keys(formValues).filter(key => key.includes('button'));
    const buttonSettings = buttonKeys.map(key => formValues[key]);
    const availableButtonTypes = BUTTON_TYPE_OPTIONS.filter(option => {
      return !buttonSettings.find(setting => setting.buttonType === option.value);
    });
    return !!availableButtonTypes.length
      ? `${productImagePrefix}_${availableButtonTypes[0].value}`
      : '';
  };

  handleToggleHideElement = item => {
    const { id, updateType, children, updateField, handleUpdateMenuSetting } = this.props;
    const cloneChildren = _.cloneDeep(children);
    const clickedElement = cloneChildren.find(child => child.value === item.value);
    clickedElement.isHidden = !clickedElement.isHidden;

    cloneChildren.forEach(child => {
      updateField(`${child.value}.isHidden`, child.isHidden);
    });
    handleUpdateMenuSetting(id, cloneChildren, updateType);
  };

  handleCloseMoveElement = () => {
    this.setState({
      isActiveMovingElementModal: false,
      movingElementInfo: null
    });
  };

  handleRemoveElement = element => {
    const {
      formValues,
      removeCurrentElement,
      updateField,
      themeName,
      updateType,
      upsertElementActions
    } = this.props;
    const elementValue = element?.value || ''; // path from formValues

    if (_.get(formValues, elementValue, null)) {
      updateField(elementValue, '');
    }

    const [prefix] = elementValue.split('_');
    let groupOfKeys = Object.keys(formValues).filter(key => {
      const [, elementKey] = key.split('_');
      return (
        key.includes(prefix) &&
        !elementKey.includes('setting') &&
        !_.isEmpty(formValues[key]) &&
        key !== elementValue
      );
    });
    groupOfKeys = _.orderBy(groupOfKeys, key => formValues[key].position, 'asc');
    groupOfKeys.forEach((key, index) => {
      updateField(`${key}.position`, index);
    });

    removeCurrentElement(elementValue, updateType);
    const removeElement = elementValue?.split('_');
    upsertElementActions('remove', {
      feature: 'Theme Settings',
      selectedTheme: themeName,
      page: removeElement[0],
      elementName: removeElement[0] + '_' + removeElement[1]
    });
  };

  render() {
    const {
      i18n,
      title,
      icon,
      id,
      activeMenuItem,
      isAddable,
      elements,
      children,
      menus,
      updateField,
      formValues,
      handleChangeActiveMenuItem,
      handleUpdateMenuSetting
    } = this.props;
    const { isOpenMenuAdd, filteredElements, isActiveMovingElementModal, movingElementInfo } =
      this.state;

    const areaChildrenClass = classnames('theme-setting-menu-children area', {
      active: id === activeMenuItem
    });
    const btnAddClass = classnames('theme-setting-menu-children btn-add', {
      disabled: _.isEmpty(filteredElements) || children.length === MAX_ELEMENT_PER_AREA
    });
    const isFullElement = children.length === MAX_ELEMENT_PER_AREA;

    return (
      <>
        <div className={areaChildrenClass} onClick={() => this.handleSelectMenuItem(id)} key={id}>
          <span className="menu-icon">{icon}</span>
          <span>{i18n.translate(title)}</span>
        </div>

        <Droppable droppableId={id} type="AreaChildren">
          {(provided, snapshot) => {
            return (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className="theme-setting-menu-droppable">
                {!!children?.length &&
                  children.map((item, index) => (
                    <Draggable key={item.value} draggableId={item.value} index={index}>
                      {(provided, snapshot) => {
                        const isDragging = snapshot.isDragging;
                        const childrenClass = classnames('theme-setting-menu-children', {
                          disabled: item.isHidden,
                          active: item.value === activeMenuItem
                        });
                        const actionClass = classnames('theme-setting-menu-children__action', {
                          show: isDragging
                        });

                        return (
                          <div>
                            {this.optionalPortal(
                              provided.draggableProps.style,
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                style={getItemStyle(isDragging, provided.draggableProps.style)}
                                className={childrenClass}
                                onClick={() => this.handleSelectMenuItem(item.value)}>
                                <span>{item.label}</span>
                                <div className={actionClass}>
                                  <span
                                    className="btn-remove"
                                    onClick={e => {
                                      e.stopPropagation();
                                      this.handleRemoveElement(item);
                                    }}>
                                    <Icon source={DeleteMinor} color="base" />
                                  </span>
                                  <span
                                    className="btn-view"
                                    onClick={e => {
                                      e.stopPropagation();
                                      this.handleToggleHideElement(item);
                                    }}>
                                    <Icon
                                      source={item.isHidden ? HideMinor : ViewMinor}
                                      color="base"
                                    />
                                  </span>
                                  <span className="btn-drag" {...provided.dragHandleProps}>
                                    <Icon source={DragHandleMinor} color="base" />
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      }}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </div>
            );
          }}
        </Droppable>

        {isAddable && !_.isEmpty(elements) && (
          <Popover
            active={isOpenMenuAdd}
            activator={
              <div className={btnAddClass} onClick={this.handleTogglePopover}>
                <Icon source={CirclePlusMajor} color="base" />
                <span>
                  {i18n.translate('AdminHTML.ThemeSetting.Common.addElement')}{' '}
                  {isFullElement ? `(${children.length}/${MAX_ELEMENT_PER_AREA})` : ''}
                </span>
              </div>
            }
            autofocusTarget="none"
            preferredAlignment="right"
            preferredPosition="mostSpace"
            onClose={this.handleTogglePopover}>
            <div className="theme-setting-menu-children__menu-add">
              <ActionList
                actionRole="menu-elements"
                sections={[
                  {
                    title: i18n.translate('AdminHTML.ThemeSetting.Elements.title'),
                    items: filteredElements.map(item => ({
                      content: i18n.translate(item.label),
                      onAction: () => this.handleAddElement(item)
                    }))
                  }
                ]}
              />
            </div>
          </Popover>
        )}

        <MovingElementModal
          activeMenuItem={activeMenuItem}
          updateField={updateField}
          formValues={formValues}
          handleChangeActiveMenuItem={handleChangeActiveMenuItem}
          handleUpdateMenuSetting={handleUpdateMenuSetting}
          active={isActiveMovingElementModal}
          movingElementInfo={movingElementInfo}
          onClose={this.handleCloseMoveElement}
          menus={menus}
        />
      </>
    );
  }
}

export default withI18n()(MenuItemArea);

MenuItemArea.defaultProps = {
  menus: []
};
